import {
    calculateDistance,
    formatCostString,
    SPHotelInfoShort,
    SPRateShort,
} from '@eventr/common'
import { ColoursObj, Typography } from '@eventr/common-storybook'
import StarRateIcon from '@mui/icons-material/StarRate'
import { Box } from '@mui/material'
import { FC } from 'react'
import i18n from '../../i18n/i18next'
import { bs } from '../../state/bound.store'
import { DistanceAwayTag } from './comps/distanceAwayTag'

type THotelPreviewCardProps = {
    hotelData: SPHotelInfoShort
    rate?: SPRateShort
}

export const HotelPreviewCard: FC<THotelPreviewCardProps> = ({
    hotelData,
    rate,
}) => {
    const eventInfoV2 = bs().getEventInfoV2()
    if (!eventInfoV2 || !eventInfoV2.data || !hotelData || !hotelData.images) {
        return null
    }

    const eventInfo = eventInfoV2.data

    return (
        <Box
            sx={{
                height: '180px',
                width: '100%',
                backgroundColor: ColoursObj.backgrounds.secondary,
                borderRadius: '8px',
            }}
        >
            <Box
                sx={{
                    height: '180px',
                    width: '100%',
                    borderRadius: '8px',
                    backgroundImage: 'url(https:' + hotelData.images[0] + ')',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                }}
            >
                <Box
                    display={'grid'}
                    gridTemplateRows={'1fr auto'}
                    height={'100%'}
                    sx={{
                        background:
                            'linear-gradient(180deg, rgba(52, 52, 52, 0) 40%, rgba(0, 0, 0, 0.5) 89%)',
                        borderRadius: '8px',
                    }}
                >
                    <Box
                        display={'grid'}
                        gridTemplateColumns={'1fr auto'}
                        padding={'8px'}
                    >
                        <Box>
                            {eventInfo &&
                                eventInfo.OSMAddress &&
                                eventInfo.OSMAddress.lat && (
                                    <DistanceAwayTag
                                        distanceAway={String(
                                            calculateDistance(
                                                [
                                                    eventInfo.OSMAddress.lat,
                                                    eventInfo.OSMAddress.lon,
                                                ],
                                                [
                                                    hotelData.coordinates[0],
                                                    hotelData.coordinates[1],
                                                ],
                                                {
                                                    unit: 'km',
                                                    format: true,
                                                    exact: true,
                                                    formatToFixed: 0,
                                                    cutOffForMorePrecision: 0,
                                                }
                                            )
                                        )}
                                    />
                                )}
                        </Box>
                        <Box
                            display={'grid'}
                            gridAutoFlow={'column'}
                            gap={'4px'}
                            sx={{
                                backgroundColor: ColoursObj.backgrounds.primary,
                                borderRadius: '24px',
                                width: 'max-content',
                                height: '24px',
                                padding: '0 8px',
                            }}
                        >
                            <StarRateIcon
                                sx={{ width: '16px', height: '24px' }}
                                htmlColor={ColoursObj.core.primary}
                            />
                            <Typography
                                variant="bodyBold"
                                lineHeight={'24px'}
                                color={ColoursObj.core.primary}
                            >
                                {hotelData.starRating}
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                        display={'grid'}
                        gridTemplateColumns={'1fr auto'}
                        padding={'8px'}
                        alignItems={'end'}
                    >
                        <Box display={'grid'}>
                            <Typography
                                variant="bodyBold"
                                color={ColoursObj.shades.shade5}
                            >
                                {hotelData.name}
                            </Typography>
                        </Box>
                        {rate && (
                            <Box display={'grid'}>
                                <Typography
                                    color={ColoursObj.shades.shade5}
                                    lineHeight={'16px'}
                                >
                                    {i18n.t('booking.perNight')}
                                </Typography>
                                <Typography
                                    variant="bodyBold"
                                    color={ColoursObj.shades.shade5}
                                    lineHeight={'24px'}
                                >
                                    {formatCostString(
                                        rate.perNight,
                                        rate.currency
                                    )}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}
